module.exports = __webpack_public_path__ + "img/33.b7662b4e.png";